'use client';
import { cn } from '@/lib/utils';
import { forwardRef, HTMLAttributes } from 'react';
import styles from './heading.module.scss';

export type HeadingProps = {
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p';
  tagClass?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | '';
  // width?: 'fixed' | 'fit';
  // widthUnit?: '%' | 'px' | 'rem';
  // widthValue?: number | null;
  paddingX?: number | null;
  paddingY?: number | null;
  fontSize?: number | null;
  content?: string;
  textAlign?: string;
} & HTMLAttributes<HTMLHeadingElement>;

export const Heading = forwardRef<HTMLHeadingElement, HeadingProps>(
  (
    {
      tag = 'h2',
      tagClass = '',
      // width = 'fixed',
      // widthUnit = '%',
      // widthValue = null,
      paddingX = null,
      paddingY = null,
      fontSize = null,
      content = '',
      color,
      textAlign,
      ...props
    },
    ref,
  ) => {
    const Tag = tag;

    return (
      <Tag
        ref={ref}
        className={cn(color, textAlign, styles.heading, tagClass)}
        {...props}
        style={{
          ...(fontSize !== null && { fontSize: `${fontSize}px` }),
          ...(paddingX !== null && { paddingLeft: `${paddingX}px`, paddingRight: `${paddingX}px` }),
          ...(paddingY !== null && { paddingTop: `${paddingY}px`, paddingBottom: `${paddingY}px` }),
        }}
      >
        {content}
      </Tag>
    );
  },
);

Heading.displayName = 'Heading';
